import stringifyJSON from 'json-stable-stringify';
import type { BaseParams, OneRequestParams } from '../utils';
import { buildRequestParams } from '../utils';
import { API } from './api';

export type GetBundleParams = BaseParams & {
  bundleIdentifier?: string;
  bundleId?: string;

  /**
   * @deprecated Use requestParams.public instead
   */
  public?: boolean;
};

/**
 * Translation Api.
 */
export class TranslateAPI extends API {
  /**
   * Gets a translation bundle.
   * @param args - Arguments for request.
   * @returns Translation bundle.
   */
  async getBundle(args: GetBundleParams): Promise<{ [key: string]: string }> {
    let body;

    if (args.bundleIdentifier) {
      body = {
        identifier: args.bundleIdentifier,
      };
    }

    const bodyAsParam = body ? encodeURIComponent(stringifyJSON(body)) : null;
    const buildRequestParamsOptions: OneRequestParams = {
      packageIdentifier: '_system',
      classIdentifier: '_translation',
      methodIdentifier: '_get',
      _id: args.bundleId,
      requestParams: {
        ...args.requestParams,
      },
    };

    if (bodyAsParam) {
      buildRequestParamsOptions.queryParams = { _body: bodyAsParam };
    }

    const requestParams = buildRequestParams(buildRequestParamsOptions);

    requestParams.public = args.public;

    const response = await this.restService.get(requestParams);

    if (response.error) return {};

    return this.getTranslations(response.data.units);
  }

  private getTranslations(bundleUnits: { key: string; value: string }[]) {
    const translation: { [key: string]: string } = {};
    (bundleUnits || []).forEach((unit) => {
      translation[unit.key] = unit.value;
    });
    return translation;
  }
}
